import { Swiper, Navigation, Autoplay } from "swiper/bundle";
export default class Swiperevents {
    constructor() {
        console.log('%c👍🏼 Swiper Events', 'color: yellow');
        
        this.swiperevents = document.querySelectorAll('.swiper-events')
    }
    init() {
        this.swiperevents.forEach((module, i) => {

            const elem = module.querySelector('.swiper--events');

            const nextButton = module.querySelector('.swiper-button-next');
            const prevButton = module.querySelector('.swiper-button-prev');
            new Swiper(elem, {
                slidesPerView: 1.5,
                loop: false,
                spaceBetween: 15,
                speed: 1001,

                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                breakpoints: {
                    540: {
                    slidesPerView: 1.7
                    },

                    768: {
                        slidesPerView: 2.2
                    },
                    998: {
                    slidesPerView: 2.5
                    },
                }
            });   
        })
    }
}